import { render } from "./OttAppsDashboard.vue?vue&type=template&id=7386c58a"
import script from "./OttAppsDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./OttAppsDashboard.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/OttApps/OttAppsDashboard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7386c58a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7386c58a', __exports__)) {
    api.reload('7386c58a', __exports__)
  }
  
  module.hot.accept("./OttAppsDashboard.vue?vue&type=template&id=7386c58a", () => {
    api.rerender('7386c58a', render)
  })

}


export default __exports__